import _map from 'lodash/map';

export default (items) => _map(items, (el) => ({
  id: el.id,
  name: el.name,
}));
